import axios from 'axios'
import { USER_LOGOUT } from '../../admin_module/constants/userConstants'

import BACKEND_URL from '../../backendUrl'
import {
  JITAI_MESSAGE_LIST_REQUEST,
  JITAI_MESSAGE_LIST_SUCCESS,
  JITAI_MESSAGE_LIST_FAIL,
  JITAI_MESSAGE_LIST_RESET,
  JITAI_MESSAGE_CREATE_REQUEST,
  JITAI_MESSAGE_CREATE_SUCCESS,
  JITAI_MESSAGE_CREATE_FAIL,
  JITAI_MESSAGE_CREATE_RESET,
  JITAI_MESSAGE_UPDATE_REQUEST,
  JITAI_MESSAGE_UPDATE_SUCCESS,
  JITAI_MESSAGE_UPDATE_FAIL,
  JITAI_MESSAGE_UPDATE_RESET,
  JITAI_MESSAGE_DELETE_REQUEST,
  JITAI_MESSAGE_DELETE_SUCCESS,
  JITAI_MESSAGE_DELETE_FAIL,
  JITAI_MESSAGE_DELETE_RESET,
  JITAI_VARIABLE_LIST_REQUEST,
  JITAI_VARIABLE_LIST_SUCCESS,
  JITAI_VARIABLE_LIST_FAIL,
  JITAI_VARIABLE_LIST_RESET,
  JITAI_VARIABLE_CREATE_REQUEST,
  JITAI_VARIABLE_CREATE_SUCCESS,
  JITAI_VARIABLE_CREATE_FAIL,
  JITAI_VARIABLE_CREATE_RESET,
  JITAI_VARIABLE_UPDATE_REQUEST,
  JITAI_VARIABLE_UPDATE_SUCCESS,
  JITAI_VARIABLE_UPDATE_FAIL,
  JITAI_VARIABLE_UPDATE_RESET,
  JITAI_VARIABLE_DELETE_REQUEST,
  JITAI_VARIABLE_DELETE_SUCCESS,
  JITAI_VARIABLE_DELETE_FAIL,
  JITAI_VARIABLE_DELETE_RESET,
  JITAI_DECISION_RULE_LIST_REQUEST,
  JITAI_DECISION_RULE_LIST_SUCCESS,
  JITAI_DECISION_RULE_LIST_FAIL,
  JITAI_DECISION_RULE_LIST_RESET,
  JITAI_DECISION_RULE_CREATE_REQUEST,
  JITAI_DECISION_RULE_CREATE_SUCCESS,
  JITAI_DECISION_RULE_CREATE_FAIL,
  JITAI_DECISION_RULE_CREATE_RESET,
  JITAI_DECISION_RULE_UPDATE_REQUEST,
  JITAI_DECISION_RULE_UPDATE_SUCCESS,
  JITAI_DECISION_RULE_UPDATE_FAIL,
  JITAI_DECISION_RULE_UPDATE_RESET,
  JITAI_DECISION_RULE_DELETE_REQUEST,
  JITAI_DECISION_RULE_DELETE_SUCCESS,
  JITAI_DECISION_RULE_DELETE_FAIL,
  JITAI_DECISION_RULE_DELETE_RESET,
  JITAI_RESP_LIST_REQUEST,
  JITAI_RESP_LIST_SUCCESS,
  JITAI_RESP_LIST_FAIL,
  JITAI_RESP_CREATE_REQUEST,
  JITAI_RESP_CREATE_SUCCESS,
  JITAI_RESP_CREATE_FAIL,
  JITAI_RESP_UPDATE_REQUEST,
  JITAI_RESP_UPDATE_SUCCESS,
  JITAI_RESP_UPDATE_FAIL,
  JITAI_RESP_DELETE_REQUEST,
  JITAI_RESP_DELETE_SUCCESS,
  JITAI_RESP_DELETE_FAIL,
  JITAI_SCHEDULED_TASK_LIST_REQUEST,
  JITAI_SCHEDULED_TASK_LIST_SUCCESS,
  JITAI_SCHEDULED_TASK_LIST_FAIL,
  JITAI_RULES_USAGE_REQUEST,
  JITAI_RULES_USAGE_SUCCESS,
  JITAI_RULES_USAGE_FAIL,
  JITAI_EVALUATE_REQUEST,
  JITAI_EVALUATE_SUCCESS,
  JITAI_EVALUATE_FAIL,
  JITAI_PARTICIPANT_ACTIVITY_REQUEST,
  JITAI_PARTICIPANT_ACTIVITY_SUCCESS,
  JITAI_PARTICIPANT_ACTIVITY_FAIL,
} from '../constants/jitaiConstants'

const standardErrorHandling = (dispatch, error, errorConstant) => {
  if (error.response && error.response.status === 401) {
    // This ensure userInfo is clear
    dispatch({
      type: USER_LOGOUT,
    })
    localStorage.removeItem('adminModuleUserInfo')
  } else {
    // In the custom express error handler, there could be custom error message,
    //  which is stored in error.response as { message: ..., stack: ... }
    // If there is no such custom error message, output the generic error message (i.e. error.message)
    dispatch({
      type: errorConstant,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getJitaiMessageList = (studyId) => async (dispatch, getState) => {
  try {
    dispatch({ type: JITAI_MESSAGE_LIST_REQUEST })

    // getState() will return the whole redux state.
    // Check store.js combineReducer to see the key of the target state.
    const {
      userLogin: { userInfo },
    } = getState()

    //Following demostrate how to create data with axios in front-end
    //Authorization does not need to be quoted
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      BACKEND_URL + `/api/jitai_messages/${studyId}`,
      config
    )

    dispatch({
      type: JITAI_MESSAGE_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_MESSAGE_LIST_FAIL)
  }
}

export const createJitaiMessage = (studyId, jitaiMessage) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_MESSAGE_CREATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      BACKEND_URL + `/api/jitai_messages/${studyId}`,
      jitaiMessage,
      config
    )

    dispatch({
      type: JITAI_MESSAGE_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_MESSAGE_CREATE_FAIL)
  }
}

export const updateJitaiMessage = (studyId, jitaiMessageId, jitaiMessage) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_MESSAGE_UPDATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      BACKEND_URL + `/api/jitai_messages/${studyId}/${jitaiMessageId}`,
      jitaiMessage,
      config
    )

    dispatch({
      type: JITAI_MESSAGE_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_MESSAGE_UPDATE_FAIL)
  }
}

export const deleteJitaiMessage = (studyId, jitaiMessageId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_MESSAGE_DELETE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(
      BACKEND_URL + `/api/jitai_messages/${studyId}/${jitaiMessageId}`,
      config
    )

    dispatch({
      type: JITAI_MESSAGE_DELETE_SUCCESS,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_MESSAGE_DELETE_FAIL)
  }
}

export const getJitaiVariableList = (studyId) => async (dispatch, getState) => {
  try {
    dispatch({ type: JITAI_VARIABLE_LIST_REQUEST })

    // getState() will return the whole redux state.
    // Check store.js combineReducer to see the key of the target state.
    const {
      userLogin: { userInfo },
    } = getState()

    //Following demostrate how to create data with axios in front-end
    //Authorization does not need to be quoted
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      BACKEND_URL + `/api/jitai_variables/${studyId}`,
      config
    )

    dispatch({
      type: JITAI_VARIABLE_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_VARIABLE_LIST_FAIL)
  }
}

export const createJitaiVariable = (studyId, jitaiVariable) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_VARIABLE_CREATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      BACKEND_URL + `/api/jitai_variables/${studyId}`,
      jitaiVariable,
      config
    )

    dispatch({
      type: JITAI_VARIABLE_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_VARIABLE_CREATE_FAIL)
  }
}

export const updateJitaiVariable = (studyId, jitaiVariableId, jitaiVariable) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_VARIABLE_UPDATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      BACKEND_URL + `/api/jitai_variables/${studyId}/${jitaiVariableId}`,
      jitaiVariable,
      config
    )

    dispatch({
      type: JITAI_VARIABLE_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_VARIABLE_UPDATE_FAIL)
  }
}

export const deleteJitaiVariable = (studyId, jitaiVariableId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_VARIABLE_DELETE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(
      BACKEND_URL + `/api/jitai_variables/${studyId}/${jitaiVariableId}`,
      config
    )

    dispatch({
      type: JITAI_VARIABLE_DELETE_SUCCESS,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_VARIABLE_DELETE_FAIL)
  }
}

export const getJitaiDecisionRuleList = (studyId) => async (dispatch, getState) => {
  try {
    dispatch({ type: JITAI_DECISION_RULE_LIST_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      BACKEND_URL + `/api/jitai_decision_rules/${studyId}`,
      config
    )

    dispatch({
      type: JITAI_DECISION_RULE_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_DECISION_RULE_LIST_FAIL)
  }
}

export const createJitaiDecisionRule = (studyId, jitaiDecisionRule) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_DECISION_RULE_CREATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      BACKEND_URL + `/api/jitai_decision_rules/${studyId}`,
      jitaiDecisionRule,
      config
    )

    dispatch({
      type: JITAI_DECISION_RULE_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_DECISION_RULE_CREATE_FAIL)
  }
}

export const updateJitaiDecisionRule = (studyId, jitaiDecisionRuleId, jitaiDecisionRule) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_DECISION_RULE_UPDATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      BACKEND_URL + `/api/jitai_decision_rules/${studyId}/${jitaiDecisionRuleId}`,
      jitaiDecisionRule,
      config
    )

    dispatch({
      type: JITAI_DECISION_RULE_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_DECISION_RULE_UPDATE_FAIL)
  }
}

export const deleteJitaiDecisionRule = (studyId, jitaiDecisionRuleId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_DECISION_RULE_DELETE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(
      BACKEND_URL + `/api/jitai_decision_rules/${studyId}/${jitaiDecisionRuleId}`,
      config
    )

    dispatch({
      type: JITAI_DECISION_RULE_DELETE_SUCCESS,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_DECISION_RULE_DELETE_FAIL)
  }
}

export const getJitaiRespList = (studyId) => async (dispatch, getState) => {
  try {
    dispatch({ type: JITAI_RESP_LIST_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      BACKEND_URL + `/api/jitai_resps/${studyId}`,
      config
    )

    dispatch({
      type: JITAI_RESP_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_RESP_LIST_FAIL)
  }
}

export const createJitaiResp = (studyId, jitaiResp) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_RESP_CREATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      BACKEND_URL + `/api/jitai_resps/${studyId}`,
      jitaiResp,
      config
    )

    dispatch({
      type: JITAI_RESP_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_RESP_CREATE_FAIL)
  }
}

export const updateJitaiResp = (studyId, jitaiRespId, jitaiResp) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_RESP_UPDATE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      BACKEND_URL + `/api/jitai_resps/${studyId}/${jitaiRespId}`,
      jitaiResp,
      config
    )

    dispatch({
      type: JITAI_RESP_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_RESP_UPDATE_FAIL)
  }
}

export const deleteJitaiResp = (studyId, jitaiRespId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: JITAI_RESP_DELETE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(
      BACKEND_URL + `/api/jitai_resps/${studyId}/${jitaiRespId}`,
      config
    )

    dispatch({
      type: JITAI_RESP_DELETE_SUCCESS,
    })
  } catch (error) {
    standardErrorHandling(dispatch, error, JITAI_RESP_DELETE_FAIL)
  }
}

export const getScheduledJitaiTaskList =
  (studyId, participantId) => async (dispatch, getState) => {
    try {
      dispatch({ type: JITAI_SCHEDULED_TASK_LIST_REQUEST })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.get(
        BACKEND_URL + `/api/jitai/${studyId}/scheduled-tasks/${participantId}`,
        config
      )

      dispatch({
        type: JITAI_SCHEDULED_TASK_LIST_SUCCESS,
        payload: data,
      })
    } catch (error) {
      standardErrorHandling(dispatch, error, JITAI_SCHEDULED_TASK_LIST_FAIL)
    }
  }

export const getDecisionRulesUsage =
  (studyId, participantId) => async (dispatch, getState) => {
    try {
      dispatch({ type: JITAI_RULES_USAGE_REQUEST })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.get(
        BACKEND_URL + `/api/jitai/${studyId}/decision-rules-usage?participantId=${participantId}`,
        config
      )

      dispatch({
        type: JITAI_RULES_USAGE_SUCCESS,
        payload: data,
      })
    } catch (error) {
      standardErrorHandling(dispatch, error, JITAI_RULES_USAGE_FAIL)
    }
  }

export const evaluateFunction =
  (studyId, body) => async (dispatch, getState) => {
    try {
      dispatch({ type: JITAI_EVALUATE_REQUEST })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.post(
        BACKEND_URL + `/api/jitai/${studyId}/evaluate`,
        body,
        config
      )

      dispatch({
        type: JITAI_EVALUATE_SUCCESS,
        payload: data,
      })
    } catch (error) {
      standardErrorHandling(dispatch, error, JITAI_EVALUATE_FAIL)
    }
  }

export const getParticipantActivity =
  (studyId, participantId, hours = 24) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: JITAI_PARTICIPANT_ACTIVITY_REQUEST })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.get(
        BACKEND_URL +
          `/api/jitai/${studyId}/participant-activity/${participantId}?hours=${hours}`,
        config
      )

      dispatch({
        type: JITAI_PARTICIPANT_ACTIVITY_SUCCESS,
        payload: data,
      })
    } catch (error) {
      standardErrorHandling(dispatch, error, JITAI_PARTICIPANT_ACTIVITY_FAIL)
    }
  }